(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["geo-store-switcher"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-geo-store-switcher]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const region = dialog.dataset.currentRegion;
    const storageKey = `cocoleni-store-choice-${region}`;

    try {
      if (sessionStorage.getItem(storageKey)) return;
    } catch (error) {}

    const rememberChoice = () => {
      try {
        sessionStorage.setItem(storageKey, 'true');
      } catch (error) {}
    };

    const closeDialog = () => {
      rememberChoice();
      dialog.close();
    };

    dialog.querySelector('[data-geo-store-close]')?.addEventListener('click', closeDialog);
    dialog.querySelector('[data-geo-store-stay]')?.addEventListener('click', closeDialog);
    dialog.addEventListener('cancel', rememberChoice);

    const switchLink = dialog.querySelector('[data-geo-store-switch]');
    const targetUrl = new URL(window.location.pathname, dialog.dataset.targetOrigin);
    targetUrl.hash = window.location.hash;
    switchLink.href = targetUrl.toString();
    switchLink.addEventListener('click', rememberChoice);

    const showForCountry = (countryCode, countryName) => {
      if (!countryCode) return;

      const isIndia = countryCode.toUpperCase() === 'IN';
      const isMismatch = region === 'india' ? !isIndia : isIndia;
      if (!isMismatch) return;

      const message = dialog.dataset.countryMessage.replace('__COUNTRY__', countryName || countryCode);
      dialog.querySelector('[data-geo-store-message]').textContent = message;
      dialog.showModal();
    };

    const root = window.Shopify?.routes?.root || '/';
    const suggestionUrl = `${root}browsing_context_suggestions.json?country[enabled]=true`;

    fetch(suggestionUrl, { credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : Promise.reject())
      .then((data) => {
        const country = data?.detected_values?.country;
        showForCountry(country?.handle, country?.name);
      })
      .catch(() => showForCountry(dialog.dataset.activeCountry, dialog.dataset.activeCountry));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-appointment-dialog"] && !Shopify.designMode) return;
  try {
    function canEmbedStoreAppointment(url) {
    try {
      const hostname = new URL(url).hostname.toLowerCase();
      return hostname === 'calendar.google.com'
        || hostname === 'calendly.com'
        || hostname.endsWith('.calendly.com')
        || hostname === 'cal.com'
        || hostname.endsWith('.cal.com');
    } catch {
      return false;
    }
  }

  function initializeStoreAppointmentDialog(dialog) {
    if (dialog.dataset.storeAppointmentInitialized === 'true') return;
    dialog.dataset.storeAppointmentInitialized = 'true';

    const closeButton = dialog.querySelector('[data-store-appointment-close]');
    const iframe = dialog.querySelector('[data-store-appointment-iframe]');
    const title = dialog.querySelector('[data-store-appointment-title]');
    const fallback = dialog.querySelector('[data-store-appointment-fallback]');
    const whatsappLink = dialog.querySelector('[data-store-appointment-whatsapp]');
    const iframeBaseTitle = iframe.title;

    closeButton.addEventListener('click', () => dialog.close());

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      iframe.removeAttribute('src');
      iframe.hidden = true;
      iframe.title = iframeBaseTitle;
      fallback.hidden = true;
      whatsappLink.href = '#';
      title.textContent = '';
    });
  }

  function initializeStoreAppointmentLink(link) {
    if (link.dataset.storeAppointmentInitialized === 'true') return;
    link.dataset.storeAppointmentInitialized = 'true';

    link.addEventListener('click', (event) => {
      const calendarUrl = link.dataset.storeCalendarUrl || '';
      const fallbackUrl = link.dataset.storeFallbackUrl || link.href || '';

      const dialogId = link.dataset.storeAppointmentDialogId;
      const dialog = document.getElementById(dialogId);
      if (!dialog) return;

      event.preventDefault();

      const iframe = dialog.querySelector('[data-store-appointment-iframe]');
      const title = dialog.querySelector('[data-store-appointment-title]');
      const fallback = dialog.querySelector('[data-store-appointment-fallback]');
      const whatsappLink = dialog.querySelector('[data-store-appointment-whatsapp]');
      const storeName = link.dataset.storeName || '';

      title.textContent = storeName;
      iframe.hidden = true;
      fallback.hidden = true;

      if (calendarUrl && canEmbedStoreAppointment(calendarUrl)) {
        iframe.title = storeName ? `${iframe.title} — ${storeName}` : iframe.title;
        iframe.src = calendarUrl;
        iframe.hidden = false;
      } else {
        whatsappLink.href = fallbackUrl;
        fallback.hidden = false;
      }

      dialog.showModal();
    });
  }

  function initializeStoreAppointments(root) {
    root.querySelectorAll('[data-store-appointment-dialog]').forEach(initializeStoreAppointmentDialog);
    root.querySelectorAll('[data-store-calendar-url]').forEach(initializeStoreAppointmentLink);
  }

  initializeStoreAppointments(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializeStoreAppointments(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
